import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import GraphHOC from './GraphHOC';
import VerticalBarGraph from '../../../../Common/BarGraph/VarticalBargraph';
import BarGraph from '../../../../Common/BarGraph/BarGraph';
import RatingDonutChart from '../../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../../Common/FunnelGraph/FunnelGraph';
import CorrelationGraph from '../../../../components/CorrelationGraph/CorrelationGraph';
import { useParsedEndDate, useParsedStartDate } from '../../../../utils/ParseDate';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-left: 25px;
    margin-right: 5px;
    box-sizing: border-box;
  & .title {
    color: #636363;
  font-family: inherit;
    font-size: 15px;
    font-weight: 500;
  }
`;
const TopHashtagsWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 0px 10px;
  align-items: center;
  margin-top: 30px;

  &>p: first-child {
    ${'' /* color: #636363; */}
  font-family: inherit;
    font-size: 15px;
    font-weight: 500;
    margin: 20px 0px 0px 10px;
  }
`;
const EmotionAnalysisWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 0px 10px;
  align-items: center;
  margin-top: 30px;

  .titleContainer {
    margin: 25px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .correlationGraphContainer {
    padding: 1px 20px 20px 20px;
  }

  & > p:first-child {
    ${'' /* color: #636363; */}
  font-family: inherit;
    font-size: 15px;
    font-weight: 500;

    margin: 20px 0px 0px 10px;
  }
`;
const ReachComponent = ({

    search_type = '',
    xyz = {},
    startDate = '',
    endDate = '',
    filterOption,
    filteredData,
    filteredStartDate,
    filteredEndDate,
    view,
    resetFlag,
    channel,
    child,
    hideDropdown,
    is_news = false,
    formatValue = 'dd-yyyy-MM'
}) => {


    const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];

    const ratingColors = ['rgba(45, 137, 85, 1)', 'rgba(45, 137, 85, 0.8)', 'rgba(45, 137, 85, 0.6)', 'rgba(45, 137, 85, 0.4)', 'rgba(45, 137, 85,0.2)'];

    function convertObjectToBarGraphData(object = {}) {
        const barGraphData = Object.entries(object).map(([name, value]) => ({
            name,
            value: value || 0,
        }));
        const sortData = barGraphData.sort((a, b) => b.value - a.value);
        const dataWithColors = sortData.map((item, index) => ({
            ...item,
            fill: ratingColors[index],
        }));

        return dataWithColors;
    }

    function checkAndConvert(obj, isHashtag) {
        if (is_news) {
            return [
                {
                    name: 'Total Positive Posts',
                    value: xyz?.sentiment_bar_chart?.total_positive_posts || 0,
                    fill: 'rgba(92, 227, 144, 1)',
                },
                {
                    name: 'Total Negative Posts',
                    value: xyz?.sentiment_bar_chart?.total_negative_posts || 0,
                    fill: 'rgba(252, 103, 88, 1)',
                },
                {
                    name: 'Total Neutral Posts',
                    value: xyz?.sentiment_bar_chart?.total_neutral_posts || 0,
                    fill: 'rgba(245, 166, 35, 1)',
                },
            ];
        } else {
            let hashtaggedObj;
            if (isHashtag === true) {
                hashtaggedObj = (obj != null || obj != undefined) && Object.fromEntries(
                    Object.entries(obj)?.map(([key, value]) => [`#${key}`, value])
                );
            } else {
                hashtaggedObj = (obj != null || obj != undefined) && Object.fromEntries(
                    Object.entries(obj)?.map(([key, value]) => [`${key}`, value])
                );
            }

            if (
                hashtaggedObj &&
                typeof hashtaggedObj === 'object' &&
                Object.keys(hashtaggedObj).length === 1 &&
                hashtaggedObj.hasOwnProperty('') &&
                hashtaggedObj[''] === 0
            ) {
                return []; // Return an empty array
            }
            // Check if there's only one key and that key is an empty string, with a value of 0
            if (hashtaggedObj && typeof hashtaggedObj === 'object') {
                // Check if there's only one key and that key is an empty string, with a value of 0

                return convertObjectToBarGraphData(hashtaggedObj); // Otherwise, return the original object
            }
        }
    }
    const topHastagsData = checkAndConvert(
        xyz?.top_five_hashtag, true
    ) || [];
    const queryHastagsData = checkAndConvert(
        xyz?.query_hashtags?.query_hashtag_counts, true
    ) || [];

    const mostMentionedFunc = () => {

        // Determine which object to use based on resetFlag
        let obj = xyz?.most_mentioned;

        // Add "@" symbol to each key of the object
        const taggedObj = (obj != null || obj != undefined) && Object.fromEntries(
            Object.entries(obj)?.map(([key, value]) => [`@${key}`, value])
        );

        // Call checkAndConvert function with the modified object
        return checkAndConvert(taggedObj) || [];

    }
    const mostMentionedFunc2 = () => {

        // Determine which object to use based on resetFlag
        let obj = xyz?.query_hashtags?.query_mentionedname_counts;

        // Add "@" symbol to each key of the object
        const taggedObj = (obj != null || obj != undefined) && Object.fromEntries(
            Object.entries(obj)?.map(([key, value]) => [`${key}`, value])
        );

        // Call checkAndConvert function with the modified object
        return checkAndConvert(taggedObj) || [];

    }

    const mostMentionedData = mostMentionedFunc() || [];
    const mostMentionedData2 = mostMentionedFunc2() || [];

    const mostAuthoritativeData = checkAndConvert(
        xyz?.most_authoritative
    ) || [];

    const renderMostAuthoritative = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph
                    data={mostAuthoritativeData}
                    maxWidth={'70%'}
                    barHeight={'32px'}
                />
            ) : (
                <BarGraph
                    data={mostAuthoritativeData}
                    maxWidth={
                        mostAuthoritativeData && mostAuthoritativeData.length > 0
                            ? '70%'
                            : '80%'
                    }
                    barHeight={'32px'}
                />
            ),

        'Pie Chart': (
            <RatingDonutChart
                data={mostAuthoritativeData}
                is_download={true}
                width={500}
                maxWidth={
                    mostAuthoritativeData && mostAuthoritativeData.length > 0
                        ? '100%'
                        : '80%'
                }
            />
        ),
        'Donut Chart': (
            <DonutChart
                data={mostAuthoritativeData}
                is_download={true}
                maxWidth={
                    mostAuthoritativeData && mostAuthoritativeData.length > 0
                        ? '100%'
                        : '80%'
                }
            />
        ),
        'Funnel Chart': (
            <FunnelGraph data={mostAuthoritativeData} maxWidth={'80%'} />
        ),

    };
    const renderMostmentioned = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph
                    data={mostMentionedData}
                    maxWidth={
                        mostMentionedData && mostMentionedData.length > 0 ? '70%' : '80%'
                    }
                    barHeight={'32px'}
                />
            ) : (
                <BarGraph
                    data={mostMentionedData}
                    maxWidth={
                        mostMentionedData && mostMentionedData.length > 0 ? '70%' : '80%'
                    }
                    barHeight={'32px'}
                />
            ),
        'Pie Chart': (
            <RatingDonutChart
                data={mostMentionedData}
                is_download={true}
                width={500}
                maxWidth={
                    mostMentionedData && mostMentionedData.length > 0 ? '100%' : '80%'
                }
            />
        ),
        'Donut Chart': (
            <DonutChart
                data={mostMentionedData}
                is_download={true}
                maxWidth={
                    mostMentionedData && mostMentionedData.length > 0 ? '100%' : '80%'
                }
            />
        ),
        'Funnel Chart': <FunnelGraph data={mostMentionedData} maxWidth={'80%'} />,
    };
    
    const renderMostmentioned2 = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph
                    data={mostMentionedData2}
                    maxWidth={
                        mostMentionedData2 && mostMentionedData2.length > 0 ? '70%' : '80%'
                    }
                    barHeight={'32px'}
                />
            ) : (
                <BarGraph
                    data={mostMentionedData2}
                    maxWidth={
                        mostMentionedData2 && mostMentionedData2.length > 0 ? '70%' : '80%'
                    }
                    barHeight={'32px'}
                />
            ),
        'Pie Chart': (
            <RatingDonutChart
                data={mostMentionedData2}
                is_download={true}
                width={500}
                maxWidth={
                    mostMentionedData2 && mostMentionedData2.length > 0 ? '100%' : '80%'
                }
            />
        ),
        'Donut Chart': (
            <DonutChart
                data={mostMentionedData2}
                is_download={true}
                maxWidth={
                    mostMentionedData2 && mostMentionedData2.length > 0 ? '100%' : '80%'
                }
            />
        ),
        'Funnel Chart': <FunnelGraph data={mostMentionedData2} maxWidth={'80%'} />,
    };
    const renderScreen = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph data={topHastagsData} />
            ) : (
                <BarGraph data={topHastagsData} maxWidth={'75%'} />
            ),
        'Pie Chart': <RatingDonutChart data={topHastagsData} width={500} is_download={true} />,
        'Donut Chart': <DonutChart data={topHastagsData} is_download={true} />,
        'Funnel Chart': <FunnelGraph data={topHastagsData} maxWidth={'95%'} />,
    };

    const renderScreen2 = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph data={queryHastagsData} />
            ) : (
                <BarGraph data={queryHastagsData} maxWidth={'75%'} />
            ),
        'Pie Chart': <RatingDonutChart data={queryHastagsData} width={500} is_download={true} />,
        'Donut Chart': <DonutChart data={queryHastagsData} is_download={true} />,
        'Funnel Chart': <FunnelGraph data={queryHastagsData} maxWidth={'95%'} />,
    };

    const startDateParsed = useParsedStartDate(
        resetFlag,
        filteredStartDate,
        startDate,
        formatValue
    );
    const endDateParsed = useParsedEndDate(
        resetFlag,
        filteredEndDate,
        endDate,
        formatValue
    );
    console.log(child,channel, "child in reach");

    return (
        <Wrapper>
            {channel == 'twitter' && child?.length > 0 && child?.[0]?.value == true && child[0]?.display == true &&

                <div
                    className="pdf-page"
                    style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                    }}>
                    <TopHashtagsWrapper className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                    }}>
                        <GraphHOC
                            title={is_news == true ? `Sentiments Bar Chart` : `Query Hashtags`}
                            // title={`Top Hashtags`}
                            options={options}

                            renderScreen={renderScreen2}
                            graphWidth={'100%'}
                            margin={xyz?.top_five_hashtag
                                ? '20px 0px 20px 50px'
                                : '20px 0px 20px 0px'
                            }
                            startDate={startDateParsed}
                            endDate={endDateParsed}
                            option={child?.[0]?.child?.find(i => i?.value === true)?.name}

                            hideDropdown={hideDropdown}
                            formatValue={formatValue}


                        />
                    </TopHashtagsWrapper>
                </div>
            }
            {(channel == 'twitter' && child?.length > 0 && child?.[1]?.value == true && child[1]?.display == true) ?

                <div
                    className="pdf-page"
                    style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                    }}>
                    <TopHashtagsWrapper className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                    }}>
                        <GraphHOC
                            title={is_news == true ? `Sentiments Bar Chart` : `Top Hashtags`}
                            // title={`Top Hashtags`}
                            options={options}

                            renderScreen={renderScreen}
                            graphWidth={'100%'}
                            margin={xyz?.top_five_hashtag
                                ? '20px 0px 20px 50px'
                                : '20px 0px 20px 0px'
                            }
                            startDate={startDateParsed}
                            endDate={endDateParsed}
                            option={child?.[1]?.child?.find(i => i?.value === true)?.name}

                            hideDropdown={hideDropdown}
                            formatValue={formatValue}


                        />
                    </TopHashtagsWrapper>
                </div>
                :
                (child?.length > 0 && child?.[0]?.value == true && child[0]?.display == true) ?

                    <div
                        className="pdf-page"
                        style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                        }}>
                        <TopHashtagsWrapper className="pdf-page" style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                        }}>
                            <GraphHOC
                                title={is_news == true ? `Sentiments Bar Chart` : `Top Hashtags`}
                                // title={`Top Hashtags`}
                                options={options}

                                renderScreen={renderScreen}
                                graphWidth={'100%'}
                                margin={xyz?.top_five_hashtag
                                    ? '20px 0px 20px 50px'
                                    : '20px 0px 20px 0px'
                                }
                                startDate={startDateParsed}
                                endDate={endDateParsed}
                                option={child?.[0]?.child?.find(i => i?.value === true)?.name}

                                hideDropdown={hideDropdown}
                                formatValue={formatValue}


                            />
                        </TopHashtagsWrapper>
                    </div>
                    :
                    <></>
            }

            {(channel == 'twitter' && child?.length > 0 && child?.[2]?.value == true && child[2]?.display == true) ?

                <div
                    className="pdf-page"
                    style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                    }}>
                    <EmotionAnalysisWrapper className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
                    }}>
                        <GraphHOC
                            formatValue={formatValue}
                            title={'Most Authoritative'}
                            options={options}
                            renderScreen={renderMostAuthoritative}
                            graphWidth={'100%'}
                            margin={mostAuthoritativeData && mostAuthoritativeData.length > 0 ? '20px 0px 20px 50px' : '20px 0px 20px 0px'}
                            option={child?.[2]?.child?.find(i => i?.value === true)?.name}

                            hideDropdown={hideDropdown}
                            startDate={startDateParsed}
                            endDate={endDateParsed}
                            infoText='Ranks the top 5 user accounts based on an authoritative score, calculated by combining the popularity score (Shares + Likes) and the reach score (Followers - Following), to identify the most influential accounts.'

                        />
                    </EmotionAnalysisWrapper>
                </div>
                :

                (child?.length > 0 && child[1]?.value == true && child[1]?.display == true) ?

                    <div
                        className="pdf-page"
                        style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                        }}>
                        <EmotionAnalysisWrapper className="pdf-page" style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
                        }}>
                            <GraphHOC
                                formatValue={formatValue}
                                title={'Most Authoritative'}
                                options={options}
                                renderScreen={renderMostAuthoritative}
                                graphWidth={'100%'}
                                margin={mostAuthoritativeData && mostAuthoritativeData.length > 0 ? '20px 0px 20px 50px' : '20px 0px 20px 0px'}
                                option={child?.[1]?.child?.find(i => i?.value === true)?.name}

                                hideDropdown={hideDropdown}
                                startDate={startDateParsed}
                                endDate={endDateParsed}
                                infoText='Ranks the top 5 user accounts based on an authoritative score, calculated by combining the popularity score (Shares + Likes) and the reach score (Followers - Following), to identify the most influential accounts.'

                            />
                        </EmotionAnalysisWrapper>
                    </div>
                    :
                    <></>
            }
            {

                (channel == 'twitter' && child?.length > 0 && child?.[3]?.value == true && child?.[3]?.display == true) &&
                <div className="pdf-page" style={{
                    pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                }}>

                    <div
                        className="pdf-page"
                        style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                        }}>
                        <EmotionAnalysisWrapper className="pdf-page" style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                        }}>
                            <GraphHOC
                                formatValue={formatValue}
                                title={'Query Mentioned'}
                                options={options}
                                renderScreen={renderMostmentioned2}
                                graphWidth={'100%'}
                                margin={mostMentionedData && mostMentionedData.length > 0 ? '20px 0px 20px 50px' : '20px 0px 20px 0px'}
                                option={child?.[3]?.child?.find(i => i?.value === true)?.name}

                                hideDropdown={hideDropdown}
                                startDate={startDateParsed}
                                endDate={endDateParsed}
                                infoText={channel === 'instagram' ?
                                    'Track the top 5 user handles mentioned across comments, highlighting the most referenced accounts.'
                                    :
                                    channel === 'facebook' ?
                                        'Track the top 5 user handles mentioned across posts, highlighting the most referenced accounts.'
                                        :
                                        'Track the top 5 user handles mentioned across posts, highlighting the most referenced accounts.'
                                }

                            />
                        </EmotionAnalysisWrapper>
                    </div>
                </div>

            }
            {
                (channel == 'twitter' && child?.length > 0 && child?.[4]?.value == true && child?.[4]?.display == true) ?
                    <div className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                    }}>

                        <div
                            className="pdf-page"
                            style={{
                                pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                            }}>
                            <EmotionAnalysisWrapper className="pdf-page" style={{
                                pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                            }}>
                                <GraphHOC
                                    formatValue={formatValue}
                                    title={'Most Mentioned'}
                                    options={options}
                                    renderScreen={renderMostmentioned}
                                    graphWidth={'100%'}
                                    margin={mostMentionedData && mostMentionedData.length > 0 ? '20px 0px 20px 50px' : '20px 0px 20px 0px'}
                                    option={child?.[4]?.child?.find(i => i?.value === true)?.name}

                                    hideDropdown={hideDropdown}
                                    startDate={startDateParsed}
                                    endDate={endDateParsed}
                                    infoText={channel === 'instagram' ?
                                        'Track the top 5 user handles mentioned across comments, highlighting the most referenced accounts.'
                                        :
                                        channel === 'facebook' ?
                                            'Track the top 5 user handles mentioned across posts, highlighting the most referenced accounts.'
                                            :
                                            'Track the top 5 user handles mentioned across posts, highlighting the most referenced accounts.'
                                    }

                                />
                            </EmotionAnalysisWrapper>
                        </div>
                    </div>
                    :


                    channel != 'youtube' &&
                    child?.length > 0 && child[2]?.value == true && child[2]?.display == true &&
                    <div className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                    }}>

                        <div
                            className="pdf-page"
                            style={{
                                pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                            }}>
                            <EmotionAnalysisWrapper className="pdf-page" style={{
                                pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
                            }}>
                                <GraphHOC
                                    formatValue={formatValue}
                                    title={'Most Mentioned'}
                                    options={options}
                                    renderScreen={renderMostmentioned}
                                    graphWidth={'100%'}
                                    margin={mostMentionedData && mostMentionedData.length > 0 ? '20px 0px 20px 50px' : '20px 0px 20px 0px'}
                                    option={child?.[2]?.child?.find(i => i?.value === true)?.name}

                                    hideDropdown={hideDropdown}
                                    startDate={startDateParsed}
                                    endDate={endDateParsed}
                                    infoText={channel === 'instagram' ?
                                        'Track the top 5 user handles mentioned across comments, highlighting the most referenced accounts.'
                                        :
                                        channel === 'facebook' ?
                                            'Track the top 5 user handles mentioned across posts, highlighting the most referenced accounts.'
                                            :
                                            'Track the top 5 user handles mentioned across posts, highlighting the most referenced accounts.'
                                    }

                                />
                            </EmotionAnalysisWrapper>
                        </div>
                    </div>
            }

            {
                (channel == 'twitter' && child?.length > 0 && child?.[5]?.value == true && child?.[5]?.display == true) ?
                    <div
                        className="pdf-page"
                        style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                        }}>
                        <div
                            className="pdf-page"
                            style={{
                                pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '30px'
                            }}
                        >
                            <CorrelationGraph
                                RatingLabels={[
                                    'Engagement',
                                    'Anger',
                                    'Neutral',
                                    'Sadness',
                                    'Disgust',
                                    'Fear',
                                    'Joy',
                                    'Surprise',
                                ]}
                                correlationAnalysisData={
                                    filteredData && resetFlag === true
                                        ? filteredData?.correlation_analysis
                                        : xyz?.correlation_analysis
                                }
                                correlation_summary={

                                    filteredData && resetFlag === true
                                        ? filteredData?.correlation_summary
                                        : xyz?.correlation_summary
                                }
                                hideDropdown={hideDropdown}
                                startDate={startDateParsed}
                                endDate={endDateParsed}
                                formatValue={formatValue}
                                showSummaryDownload={false}
                            />
                        </div>
                    </div>
                    :



                    child?.length > 0 && child[3]?.value == true &&

                    <div
                        className="pdf-page"
                        style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                        }}>
                        <div
                            className="pdf-page"
                            style={{
                                pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '30px'
                            }}
                        >
                            <CorrelationGraph
                                RatingLabels={[
                                    'Engagement',
                                    'Anger',
                                    'Neutral',
                                    'Sadness',
                                    'Disgust',
                                    'Fear',
                                    'Joy',
                                    'Surprise',
                                ]}
                                correlationAnalysisData={
                                    filteredData && resetFlag === true
                                        ? filteredData?.correlation_analysis
                                        : xyz?.correlation_analysis
                                }
                                correlation_summary={

                                    filteredData && resetFlag === true
                                        ? filteredData?.correlation_summary
                                        : xyz?.correlation_summary
                                }
                                hideDropdown={hideDropdown}
                                startDate={startDateParsed}
                                endDate={endDateParsed}
                                formatValue={formatValue}
                                showSummaryDownload={false}
                            />
                        </div>
                    </div>
            }
        </Wrapper>
    );
};

export default ReachComponent;
